"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditBidderResolver = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//INTERNAL LIBRARY BITS
const bidder_service_1 = require("./bidder.service");
const loading_service_1 = require("./loading.service");
let EditBidderResolver = class EditBidderResolver {
    constructor(_bidder, _loading) {
        this._bidder = _bidder;
        this._loading = _loading;
    }
    resolve(route) {
        this._loading.start("Loading Bidder...");
        const id = this._bidder.bidderId != 0 ? this._bidder.bidderId : +route.params['id'];
        return this._bidder.getBidderDetail(id);
    }
};
exports.EditBidderResolver = EditBidderResolver;
exports.EditBidderResolver = EditBidderResolver = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [bidder_service_1.BidderService, loading_service_1.LoadingService])
], EditBidderResolver);
//# sourceMappingURL=edit-bidder.resolver.js.map